import { render, staticRenderFns } from "./BarGraph.vue?vue&type=template&id=6fdef87a&"
import script from "./BarGraph.vue?vue&type=script&lang=js&"
export * from "./BarGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports